import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileCard from '../components/ProfileCard';
import blueImage from '../images/blue.png';
import greyImage from '../images/grey.png';
import redImage from '../images/red.png';
import yellowImage from '../images/yellow.png';
import { playSound } from '../utils/sounds';
import './browse.css';

const Browse: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const profiles = [
    {
      name: "recruiter",
      image: blueImage,
      backgroundGif: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExOTZ5eWwwbjRpdWM1amxyd3VueHhteTVzajVjeGZtZGJ1dDc4MXMyNCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9dg/16u7Ifl2T4zYfQ932F/giphy.gif"
    },
    {
      name: "developer",
      image: greyImage,
      backgroundGif: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExNGNidDl5emZpejY2eGFxa2I4NW0zZGNpbWRlbnBrZ3N2dWhhbzM1MyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/TFPdmm3rdzeZ0kP3zG/giphy.gif"
    },
    {
      name: "stalker",
      image: redImage,
      backgroundGif: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExc28yMjMyZmJ6eWtxbmNwdDV6cXk4dWZmcjFhZms2cXBjN2h5ZDJjeSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/QjZXUBUr89CkiWLPjL/giphy.gif"
    },
    {
      name: "adventurer",
      image: yellowImage,
      backgroundGif: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExbmxib24ycWo2cjlmazh0NGV5NTZ2Mzd2YWY0M2tvam9oYXBwYW1ocCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/ERKMnDK6tkzJe8YVa3/giphy-downsized-large.gif"
    },
  ];

  const handleProfileClick = (profile: { name: string; image: string; backgroundGif: string }) => {
    // Play click sound
    playSound('https://www.soundjay.com/misc/sounds/button-3.mp3', 0.2);
    setIsLoading(true);
    
    // Add a slight delay to show loading state (like Netflix)
    setTimeout(() => {
      navigate(`/profile/${profile.name}`, { 
        state: { 
          profileImage: profile.image, 
          backgroundGif: profile.backgroundGif 
        } 
      });
      setIsLoading(false);
    }, 800);
  };

  const handleAlternativePortfolio = () => {
    playSound('https://www.soundjay.com/misc/sounds/button-09.mp3', 0.2);
    window.open('https://mantavya-backup-portfolio.vercel.app/', '_blank');
  };

  return (
    <div className="browse-container">
      {isLoading && (
        <div className="loading-overlay">
          <div className="netflix-spinner"></div>
        </div>
      )}
      
      <div className="browse-header">
        <h1 className="who-is-watching">Who's Watching?</h1>
        <p className="browse-subtitle">Choose your viewing experience</p>
      </div>

      <div className="profiles-container">
        <div className="profiles">
          {profiles.map((profile, index) => (
            <div key={index} className="profile-wrapper">
              <ProfileCard
                name={profile.name}
                image={profile.image}
                onClick={() => handleProfileClick(profile)}
              />
            </div>
          ))}
        </div>

        <div className="alternative-section">
          <div className="divider">
            <span className="divider-text">or</span>
          </div>
          
          <button className="alternative-portfolio-btn" onClick={handleAlternativePortfolio}>
            <span className="btn-text">Traditional Portfolio</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Browse;